module.exports = __webpack_public_path__ + "img/gs02.850b68ed.jpg";